import React from 'react';
import * as styledComponents from './styles'
import { Container, Row, Col } from 'react-bootstrap';
import REC from 'media/rec.png';
import { useHistory } from "react-router";
import VisibilitySensor from 'react-visibility-sensor';

const StartupRecruiting =  React.forwardRef((props, ref) => {
  const history = useHistory();
  const changeVisibility = (isVisible)=>{
    if(isVisible){
      history.push('landing?section=startuphr&type=scrolled')
    }
  }
  return (
    <styledComponents.StartupRecruitingContainer ref={ref}>
      <Container>
        <Row>
          <Col md>
            <styledComponents.ContainerListDesktop>
              <styledComponents.RECImage src={REC} />
            </styledComponents.ContainerListDesktop>
          </Col>
          <Col md>
            <styledComponents.HeadTitle>SERVICES</styledComponents.HeadTitle>
            <styledComponents.Title>
              WE RECRUIT FOR YOUR STARTUP
            </styledComponents.Title>
            <styledComponents.ContainerListPhone>
              <styledComponents.RECImage src={REC} />
            </styledComponents.ContainerListPhone>
            <styledComponents.Description>
              We assemble an optimal team for your startup and establish a development in which you can have a daily track. In this way, you can adjust your product faster and more efficiently when your client needs it.
              According to the needs, we find the most qualified people to develop the startup along with you.
              <b>Investment: Recruiting Fee</b>
            </styledComponents.Description>
            <styledComponents.CallToAction onClick={() => { window.open("https://calendly.com/luisenriquecgongora") }}>LEARN MORE</styledComponents.CallToAction>
          </Col>
        </Row>
      </Container>
    </styledComponents.StartupRecruitingContainer>
  );
});

export default StartupRecruiting;
